import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import navLinks from '../../../config/navLinks';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setChannel } from "../../../Reducers/channelReducer";
import { changeLanguage } from 'i18next';
import "./Sidebar.css"

const Sidebar = ({ showMenu = false, channelList }) => {
    const [currentChannel, setCurrentChannel] = useState({});
    const [showList, setShowList] = useState(false);

    const { t } = useTranslation();
    const location = useLocation();

    const dispatch = useDispatch();

    useEffect(() => {
        const channel = channelList.find(item => item.lang.slice(0, 2) === localStorage.getItem('i18nextLng').slice(0, 2));
        if (channel) {
            setCurrentChannel(channel);
            dispatch(setChannel(channel));
            changeLanguage(channel.lang);
        }
    }, [channelList])

    const changeChannel = (channel) => {
        setCurrentChannel(channel);
        dispatch(setChannel(channel));
        changeLanguage(channel.lang);
        setShowList(false);
    }

    const toggleList = () => {
        setShowList(prev => !prev);
    };

    return (
        <div className={`drawer-menu d-flex d-md-none flex-column justify-content-center align-items-center costa-header text-uppercase ${showMenu ? "show" : ""}`}>
            <div className="header-items container fluid">
                {
                    navLinks.map((link) => {
                        return (
                            <Link key={link.label} to={link.path} className="drawer-item text-decoration-none">
                                <div className={`drawer-link ${location.pathname === link.path ? "active" : ""}`}>
                                    {t(link.label)}
                                </div>
                            </Link>
                        )
                    })
                }
                <a className="drawer-item text-decoration-none" onClick={toggleList}>
                    <div className="drawer-link">
                        {currentChannel.name}&nbsp;
                        <i className="bi bi-caret-down-fill"></i>
                    </div>
                </a>
                <div className={`flex-column p-4 pt-0 ${showList ? "d-flex" : "d-none"}`}>
                    {channelList && channelList.map((item, index) => {
                        return (
                            <a className='drawer-link p-2 text-decoration-none' key={item.channelGuid} onClick={() => changeChannel(item)}>{item.name}</a>
                        )
                    })}
                </div>
            </div >
        </div >
    )
}

export default Sidebar